module.exports = __webpack_public_path__ + "img/cc63738.png";